import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType, } from "react-router-dom";
const OPP_MICRO_FRONTENDS = {
    planta: { route: "planner", assetPrefixes: ["workload", "activity"] },
    budgeting: { route: "budgeting", assetPrefixes: ["budget"] },
    costCenter: { route: "cc", assetPrefixes: ["cc-dept"] },
    workloadDrivers: { route: "workloadDrivers", assetPrefixes: ["drivers"] },
    modulation: { route: "modulation", assetPrefixes: ["modulation"] },
    forecasting: { route: "forecasting", assetPrefixes: ["forecast"] },
    dashboard: { route: "dashboard", assetPrefixes: ["dashboard"] },
};
export function initSentry(sentryDsn, sentryRelease, environment, parentApp) {
    Sentry.init({
        dsn: sentryDsn,
        release: sentryRelease,
        environment: environment,
        tracesSampleRate: 1.0,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.reactRouterBrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        beforeSend(event, hint) {
            const error = hint.originalException;
            if (error instanceof Error &&
                (error.name === "AbortError" ||
                    error.message?.includes("AbortError") ||
                    error.message?.toLowerCase().includes("aborted"))) {
                return null;
            }
            const errorMessage = error instanceof Error ? error.message : String(error);
            const eventMessage = event.message ?? "";
            const combinedMessage = `${errorMessage} ${eventMessage}`.toLowerCase();
            if (combinedMessage.includes("failed to fetch dynamically imported module") ||
                combinedMessage.includes("chunkloaderror") ||
                combinedMessage.includes("loading chunk") ||
                combinedMessage.includes("importing a module script failed") ||
                combinedMessage.includes("/parcel-") ||
                combinedMessage.includes("/assets/parcel-")) {
                return null;
            }
            if ((error instanceof TypeError ||
                (error instanceof DOMException && error.name === "NetworkError")) &&
                (combinedMessage.includes("failed to fetch") ||
                    combinedMessage.includes("networkerror"))) {
                return null;
            }
            if (parentApp !== undefined && parentApp !== null && parentApp !== "") {
                if (combinedMessage.includes("failed to fetch dynamically imported module")) {
                    const otherApps = Object.entries(OPP_MICRO_FRONTENDS).filter(([key]) => key !== parentApp);
                    const isOtherAppError = otherApps.some(([, app]) => {
                        return app.assetPrefixes.some((prefix) => {
                            const assetPatterns = [
                                `assets/${prefix}-`,
                                `assets/${prefix}/`,
                                `/${prefix}-`,
                                `/${app.route}/`,
                            ];
                            return assetPatterns.some((pattern) => combinedMessage.includes(pattern));
                        });
                    });
                    const stackTrace = error instanceof Error &&
                        error.stack !== undefined &&
                        error.stack !== null
                        ? error.stack
                        : "";
                    const hasOtherAppAssetInStack = stackTrace !== "" &&
                        otherApps.some(([, app]) => app.assetPrefixes.some((prefix) => stackTrace.toLowerCase().includes(`assets/${prefix}-`)));
                    if (isOtherAppError || hasOtherAppAssetInStack) {
                        console.log(`[Sentry] Filtered cross-app dynamic import error from ${parentApp} Sentry:`, combinedMessage.substring(0, 150));
                        return null;
                    }
                }
            }
            return event;
        },
    });
}
//# sourceMappingURL=sentry.js.map